import {
    Box,
    Button,
    Modal,
    Typography,
    IconButton,
    Stepper,
    Step,
    StepLabel,
    styled,
    CircularProgress,
    Alert,
    Chip,
  } from "@mui/material";
  import StepConnector, {
    stepConnectorClasses,
  } from "@mui/material/StepConnector";
  import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
  import React, { useEffect, useRef, useState } from "react";
  import { useSelector } from "react-redux";
  import Close from "./Assets/Images/close.svg";
  import { toast } from "react-toastify";
  // import { uploadFileToS3 } from "./utils/Helper";
  import getTenantIdFromURL from "./utils/getTenantIdFromURL";
  import { useDropzone } from "react-dropzone";
  import PropTypes from "prop-types";
  import * as XLSX from 'xlsx';
  import { getBulkUploadSignedUrl, processBulkUpload, suggestProspectMapping } from './api/companyApi';
  import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
  import Divider from '@mui/material/Divider';
  import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
  import ReplayIcon from '@mui/icons-material/Replay';
import { sendGeneralEmail } from "./api/tenantApi";
import { publish } from "./events";
  
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "833px",
    bgcolor: "background.paper",
    borderRadius: "20px",
    boxShadow: "inset 0px 1px 3px #0000001A, 0px 3px 6px #00000029",
  };
  
  const modalStyle = {
    backdropFilter: "blur(2px)",
    backgroundColor: "rgb(255, 255, 255, 0.5)",
  };
  
  const stepperStyle = {
    background: "#5186EC1A",
    height: "82px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  };
  
  const dropzoneStyle = {
    width: "60%",
    border: "2px dashed #5186EC",
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center",
    cursor: "pointer",
    margin: "20px auto",
  };
  
  const buttonStyle = {
    mt: 2,
    backgroundColor: "#5186EC",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#4069D0",
    },
    borderRadius: "8px",
  };
  
  const requiredColumns = ['Company Name', 'Country'];
  const optionalColumns = [
    'Address',
    'City',
    'State / Province',
    'Postal Code',
    'Registration Number',
    'Requested Amount',
    'Symbol',
    'DnB ID',
  ];
  
  const ProspectFileUploadModal = (props) => {
    const { open, onClose, counter, tenantName } = props;
    const [activeStep, setActiveStep] = useState(0);
    const [file, setFile] = useState(null);
    const [fileData, setFileData] = useState([]);
    const [fileHeaders, setFileHeaders] = useState([]);
    const [columnMapping, setColumnMapping] = useState({});
    const [mappingConfidence, setMappingConfidence] = useState({});
    const [aiMappingState, setAiMappingState] = useState('idle');
    const [aiWarnings, setAiWarnings] = useState([]);
    const [validationErrors, setValidationErrors] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [tenantId, setTenantId] = useState();
    const [showOverageWarning, setShowOverageWarning] = useState(false);
    const [overageCount, setOverageCount] = useState(0);
    const aiRequestRef = useRef(0);
    const uploadAbortControllerRef = useRef(null);
    console.log("🚀 ~ tenantId:", tenantId)
  
    const isAdmin = useSelector((state) => state.userInfo.isAdmin);
    const currentTenant = useSelector((state) => state.userInfo.tenantId);
    const URLTenant = getTenantIdFromURL();
  
    const selectTenantId = () => {
      if (isAdmin) setTenantId(URLTenant);
      else setTenantId(currentTenant);
    };
  
    useEffect(() => {
      selectTenantId();
    }, [isAdmin, currentTenant, URLTenant]);
  
    const { getRootProps, getInputProps } = useDropzone({
      accept: {
        'text/csv': ['.csv'],
        'application/vnd.ms-excel': ['.xls'],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
      },
      maxFiles: 1,
      onDrop: acceptedFiles => {
        if (acceptedFiles.length) {
          setFile(acceptedFiles[0]);
          parseFile(acceptedFiles[0]);
        }
      }
    });
  
    const parseFile = (file) => {
      const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
          if (jsonData.length > 0) {
            const headers = jsonData[0];
            const rows = jsonData.slice(1)
              .map(row => {
                return headers.reduce((obj, header, index) => {
                  obj[header] = row[index];
                  return obj;
                }, {});
              })
              .filter(rowObj => {
                return Object.values(rowObj).some(value => value !== null && value !== undefined && value.toString().trim() !== '');
              });
            handleParsedData(rows, headers);
          }
        };
        reader.readAsArrayBuffer(file);
      }
  
    const getKeywordMapping = (headers) => {
      const columnKeywords = {
        'Company Name': [
          'company name', 'name', 'company', 'prospect name', 'prospect', 'org name', 'organization', 'organisation', 'entity name', 'legal name'
        ],
        'Country': [
          'country', 'nation', 'country name', 'location', 'region', 'jurisdiction'
        ],
        'Address': [
          'address', 'street address', 'address line 1', 'address1', 'street', 'registered address', 'headquarters address', 'hq address'
        ],
        'City': [
          'city', 'locality', 'town', 'municipality'
        ],
        'State / Province': [
          'state', 'province', 'state province', 'region', 'county', 'administrative area'
        ],
        'Postal Code': [
          'postal code', 'postcode', 'zip code', 'zipcode', 'zip'
        ],
        'Registration Number': [
          'registration number', 'company registration number', 'company number', 'business number', 'tax id', 'vat number', 'registration id'
        ],
        'Symbol': [
          'symbol', 'ticker', 'stock symbol', 'exchange symbol', 'ticker symbol'
        ],
        'DnB ID': [
          'dnb id', 'duns', 'duns number', 'duns id', 'dnb', 'd&b', 'd&b id', 'dunsnumber', 'duns_no', 'duns no'
        ],
        'Requested Amount': [
          'requested amount', 'amount requested', 'requested credit limit', 'credit limit', 'limit', 'requested limit', 'credit', 'creditlimit', 'req credit limit', 'req limit', 'credit_limit', 'creditlimitrequested', 'requested exposure', 'exposure requested'
        ]
      };
      const normalize = str => String(str || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const normalizedHeaders = headers.map(h => normalize(h));
      const mapping = {};
      const usedHeaderIndexes = new Set();
      Object.entries(columnKeywords).forEach(([logicalCol, keywords]) => {
        for (const keyword of keywords) {
          const idx = normalizedHeaders.findIndex((h, headerIndex) =>
            !usedHeaderIndexes.has(headerIndex) && h.includes(normalize(keyword)));
          if (idx !== -1) {
            mapping[logicalCol] = headers[idx];
            usedHeaderIndexes.add(idx);
            break;
          }
        }
      });
      return mapping;
    };

    const runAiMapping = async (data, headers, fallbackMapping = getKeywordMapping(headers)) => {
      const requestId = ++aiRequestRef.current;
      setAiMappingState('analyzing');
      setAiWarnings([]);
      setMappingConfidence({});
      setColumnMapping(fallbackMapping);
      try {
        const sampleRows = data.slice(0, 8).map(row => headers.map(header => row[header] ?? null));
        const result = await suggestProspectMapping(headers, sampleRows);
        if (requestId !== aiRequestRef.current) return;
        const aiMappings = result?.mappings || {};
        const resolved = { ...fallbackMapping };
        const confidence = {};
        Object.entries(aiMappings).forEach(([target, entry]) => {
          if (entry?.column && headers.includes(entry.column)) {
            resolved[target] = entry.column;
            confidence[target] = Number(entry.confidence) || 0;
          }
        });
        setColumnMapping(resolved);
        setMappingConfidence(confidence);
        setAiWarnings(Array.isArray(result?.warnings) ? result.warnings : []);
        setAiMappingState(Object.keys(aiMappings).length ? 'success' : 'fallback');
      } catch (error) {
        if (requestId !== aiRequestRef.current) return;
        setAiMappingState('fallback');
        setAiWarnings([error?.response?.data?.message || 'AI analysis is unavailable. Suggested columns were filled using header matching.']);
      }
    };

    const handleParsedData = (data, headers) => {
      setFileData(data);
      setFileHeaders(headers);
      const fallbackMapping = getKeywordMapping(headers);
      setActiveStep(1);
      runAiMapping(data, headers, fallbackMapping);
    };
  
    const handleMappingChange = (requiredColumn, fileHeader) => {
      setColumnMapping(prev => ({
        ...prev,
        [requiredColumn]: fileHeader
      }));
      setMappingConfidence(prev => {
        const next = { ...prev };
        delete next[requiredColumn];
        return next;
      });
    };
  
    const validateMapping = () => {
      const errors = [];
      
      // Check required columns are mapped
      requiredColumns.forEach(col => {
        if (!columnMapping[col]) {
          errors.push(`${col} is required but not mapped`);
        }
      });
      
      // Validate data based on mappings
      fileData.forEach((row, index) => {
        // Skip fully empty rows
        const isEmptyRow = Object.values(row).every(value => value === null || value === undefined || value === '');
        if (isEmptyRow) return;
    
        requiredColumns.forEach(col => {
          const mappedCol = columnMapping[col];
          if (mappedCol && !row[mappedCol]) {
            errors.push(`Row ${index + 1}: ${col} is empty`);
          }
        });
      });
    
      setValidationErrors(errors);
      return errors.length === 0;
    };
    
  
    const handleNext = () => {
      if (activeStep === 1) {
        if (!validateMapping()) {
          return;
        }
      }
      setActiveStep(prev => prev + 1);
    };
  
    const handleBack = () => {
      setActiveStep(prev => prev - 1);
    };
  
    const actuallyUpload = async () => {
      const controller = new AbortController();
      uploadAbortControllerRef.current?.abort();
      uploadAbortControllerRef.current = controller;
      setIsUploading(true);
      try {
        // Transform data based on mapping
        const jsonData = fileData.map(row => {
          const jsonObj = {};
          Object.entries(columnMapping).forEach(([targetCol, sourceCol]) => {
            if (row[sourceCol] !== undefined) {
              jsonObj[targetCol] = row[sourceCol];
            }
          });
          return jsonObj;
        });
  
        // Create a JSON file blob
        const jsonBlob = new Blob([JSON.stringify(jsonData)], { type: 'application/json' });
        const filename = `${file.name.split('.')[0]}-${Date.now()}.json`;
  
        // Request signed URL from backend using gcpService
        const signedUrlResp = await getBulkUploadSignedUrl(tenantId, filename, controller.signal);
        if (!signedUrlResp.success) throw new Error('Failed to get signed URL');
  
        // Upload JSON to GCS using signed URL
        const response = await fetch(signedUrlResp.url, {
          method: 'PUT',
          body: jsonBlob,
          headers: { 
            'Content-Type': 'application/json'
          },
          signal: controller.signal,
        });
        
        if (!response.ok) {
          throw new Error(`Upload failed: ${response.statusText}`);
        }
  
        // Process the uploaded file to create companies
        const processResp = await processBulkUpload(tenantId, filename, controller.signal);
        if (!processResp.success) {
          throw new Error(processResp.message || 'Failed to process uploaded file');
        }

        publish('prospect_import_started', { tenantId, jobId: processResp.jobId });

        // All uploads are now processed asynchronously
        toast.success(`File uploaded successfully!`);
        onClose();
      } catch (error) {
        if (error?.name === 'AbortError' || error?.code === 'ERR_CANCELED') {
          toast.info('File upload stopped.');
          return;
        }
        console.error('Error uploading file:', error);
        toast.error(error.message || 'Error uploading file');
      } finally {
        if (uploadAbortControllerRef.current === controller) {
          uploadAbortControllerRef.current = null;
        }
        setIsUploading(false);
      }
    };

    const stopFileUpload = () => {
      if (!uploadAbortControllerRef.current) return;
      uploadAbortControllerRef.current.abort();
    };

    const sendOverageEmail = async () => {
      try {
        const message = `
        <b>Overage Alert for Tenant ${tenantId}:</b><br><br>
        <b>Tenant Name:</b> ${tenantName}<br>
        <b>Number of companies allowed:</b> ${counter}<br>
        <b>Number of companies uploaded:</b> ${fileData.length}<br>
        <b>Number of companies over the limit:</b> ${overageCount}<br><br>
        The user has agreed to proceed and accept extra billing.
      `;
        await sendGeneralEmail({
          tenantId,
          subject: "Bulk Upload Overage Alert",
          message,
          to: ['michal@crediarc.com', 'nimrod.lanir@crediarc.com']
        });
        console.log("Overage email sent successfully");
      } catch (error) {
        toast.error("Failed to send overage notification email");
      }
    };

    const convertToJsonAndUpload = async () => {
      const companiesLeft = counter;
      const companiesToUpload = fileData.length;
      if (companiesToUpload > companiesLeft) {
        setOverageCount(companiesToUpload - companiesLeft);
        setShowOverageWarning(true);
        return;
      }
      await actuallyUpload();
    };

    const handleClose = () => {
      uploadAbortControllerRef.current?.abort();
      uploadAbortControllerRef.current = null;
      setActiveStep(0);
      setFile(null);
      setFileData([]);
      setFileHeaders([]);
      setColumnMapping({});
      setMappingConfidence({});
      setAiMappingState('idle');
      setAiWarnings([]);
      aiRequestRef.current += 1;
      setValidationErrors([]);
      setIsUploading(false);
      onClose();
    };
    
  
    const steps = ['Upload & Analyze', 'Review Mapping', 'Review & Upload'];
  
    return (
      <>
        {/* Overage Warning Modal */}
        <Modal open={showOverageWarning} onClose={() => setShowOverageWarning(false)}>
          <Box
            sx={{
              ...style,
              width: 420,
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              border: '2px solid #5186EC',
              boxShadow: 24,
            }}
          >
            <WarningAmberRoundedIcon sx={{ fontSize: 48, color: '#5186EC', mb: 1 }} />
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, textAlign: 'center' }}>
              Company Upload Limit Exceeded
            </Typography>
            <Typography sx={{ mb: 1, textAlign: 'center' }}>
              Based on your contract, you can add up to <b>{counter}</b> additional compan{counter !== 1 ? 'ies' : 'y'},<br />
              and you're trying to add <b>{fileData.length}</b> companies.
            </Typography>
            <Typography sx={{ mb: 2, color: '#5186EC', fontWeight: 500, textAlign: 'center' }}>
              You are exceeding your limit by <b>{overageCount}</b> compan{overageCount !== 1 ? 'ies' : 'y'}.
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, textAlign: 'center' }}>
              Proceeding with this flow will cost extra money and we'll send you the billing.<br />
              If you have any questions, please contact your CrediArc representative.
            </Typography>
            <Divider sx={{ width: '100%', mb: 2 }} />
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, width: '100%' }}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={async () => {
                  setShowOverageWarning(false);
                  await sendOverageEmail();
                  await actuallyUpload();
                }}
              >
                Agree and Proceed
              </Button>
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                onClick={() => setShowOverageWarning(false)}
              >
                Back
              </Button>
            </Box>
          </Box>
        </Modal>
        {/* Main Modal */}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="file-upload-modal"
          aria-describedby="modal-for-uploading-company-data"
          sx={modalStyle}
        >
          <Box sx={style}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px 30px",
              }}
            >
              <Typography variant="h5">Upload Prospect Companies</Typography>
              <IconButton onClick={handleClose}>
                { <img src={Close} alt="close" /> }
              </IconButton>
            </Box>
  
            <Box sx={stepperStyle}>
              <Stepper activeStep={activeStep} connector={<ColorlibConnector />}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
  
            <Box sx={{ padding: "30px" }}>
              {activeStep === 0 && (
                <Box {...getRootProps()} sx={dropzoneStyle}>
                  <input {...getInputProps()} />
                  <AutoAwesomeIcon sx={{ color: '#6C4BEF', fontSize: 34, mb: 1 }} />
                  <Typography sx={{ fontWeight: 700, color: '#23395d', mb: 0.75 }}>
                    AI-powered company import
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Drag and drop a CSV or Excel file here, or click to select
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    AI analyzes the headers and sample values, then maps your columns automatically.<br />
                    Supported formats: .csv, .xls, .xlsx
                  </Typography>
                  {file && (
                    <Typography variant="body2" sx={{ mt: 2 }}>
                      Selected file: {file.name}
                    </Typography>
                  )}
                </Box>
              )}
  
              {activeStep === 1 && (
                <Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, mb: 2 }}>
                    <Box>
                      <Typography variant="h6">Review the AI column mapping</Typography>
                      <Typography sx={{ fontSize: 12.5, color: '#64748b' }}>Confirm or change any field before continuing.</Typography>
                    </Box>
                    <Button
                      variant="outlined"
                      size="small"
                      disabled={aiMappingState === 'analyzing'}
                      onClick={() => runAiMapping(fileData, fileHeaders)}
                      startIcon={aiMappingState === 'analyzing' ? <CircularProgress size={14} /> : <ReplayIcon />}
                      sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
                    >
                      {aiMappingState === 'analyzing' ? 'Analyzing…' : 'Analyze again'}
                    </Button>
                  </Box>
                  {aiMappingState === 'analyzing' && (
                    <Alert severity="info" icon={<AutoAwesomeIcon />} sx={{ mb: 2 }}>
                      AI is reading the column names and sample values and preparing the mapping…
                    </Alert>
                  )}
                  {aiMappingState === 'success' && (
                    <Alert severity="success" icon={<AutoAwesomeIcon />} sx={{ mb: 2 }}>
                      Columns mapped automatically. Review the selections and confidence levels below.
                    </Alert>
                  )}
                  {aiMappingState === 'fallback' && (
                    <Alert severity="warning" sx={{ mb: 2 }}>
                      AI could not complete the mapping. Header-based suggestions are shown and can be edited manually.
                    </Alert>
                  )}
                  {aiWarnings.length > 0 && (
                    <Box sx={{ mb: 2, px: 1.5, py: 1, bgcolor: '#fff8e1', border: '1px solid #ffe0a3', borderRadius: 2 }}>
                      {aiWarnings.map((warning, index) => (
                        <Typography key={index} sx={{ fontSize: 12, color: '#7c5d16' }}>• {warning}</Typography>
                      ))}
                    </Box>
                  )}
                  <Box sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {requiredColumns.map((column) => (
                      <FormControl fullWidth sx={{ mb: 2 }} key={`required-${column}`}>
                        <InputLabel>{column} *</InputLabel>
                        <Select
                          disabled={aiMappingState === 'analyzing'}
                          value={columnMapping[column] || ''}
                          onChange={(e) => handleMappingChange(column, e.target.value)}
                          label={`${column} *`}
                        >
                          <MenuItem value="">
                            <em>Select a column</em>
                          </MenuItem>
                          {fileHeaders.map((header) => (
                            <MenuItem key={header} value={header}>
                              {header}
                            </MenuItem>
                          ))}
                        </Select>
                        {mappingConfidence[column] != null && (
                          <Chip
                            size="small"
                            icon={<AutoAwesomeIcon />}
                            label={`AI confidence ${Math.round(mappingConfidence[column] * 100)}%`}
                            color={mappingConfidence[column] >= 0.8 ? 'success' : 'warning'}
                            variant="outlined"
                            sx={{ mt: 0.75, alignSelf: 'flex-start', height: 23, fontSize: 11 }}
                          />
                        )}
                      </FormControl>
                    ))}
                    {optionalColumns.map((column) => (
                      <FormControl fullWidth sx={{ mb: 2 }} key={`optional-${column}`}>
                        <InputLabel>{column} (Optional)</InputLabel>
                        <Select
                          disabled={aiMappingState === 'analyzing'}
                          value={columnMapping[column] || ''}
                          onChange={(e) => handleMappingChange(column, e.target.value)}
                          label={`${column} (Optional)`}
                        >
                          <MenuItem value="">
                            <em>Select a column</em>
                          </MenuItem>
                          {fileHeaders.map((header) => (
                            <MenuItem key={header} value={header}>
                              {header}
                            </MenuItem>
                          ))}
                        </Select>
                        {mappingConfidence[column] != null && (
                          <Chip
                            size="small"
                            icon={<AutoAwesomeIcon />}
                            label={`AI confidence ${Math.round(mappingConfidence[column] * 100)}%`}
                            color={mappingConfidence[column] >= 0.8 ? 'success' : 'warning'}
                            variant="outlined"
                            sx={{ mt: 0.75, alignSelf: 'flex-start', height: 23, fontSize: 11 }}
                          />
                        )}
                      </FormControl>
                    ))}
                  </Box>
                  {validationErrors.length > 0 && (
                    <Box sx={{ mt: 2, color: 'error.main' }}>
                      <Typography variant="subtitle2">Validation Errors:</Typography>
                      <ul>
                        {validationErrors.slice(0, 5).map((error, index) => (
                          <li key={index}>{error}</li>
                        ))}
                        {validationErrors.length > 5 && (
                          <li>...and {validationErrors.length - 5} more</li>
                        )}
                      </ul>
                    </Box>
                  )}
                </Box>
              )}
  
              {activeStep === 2 && (
                <Box>
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Review your data
                  </Typography>
                  <Box sx={{ maxHeight: '400px', overflowY: 'auto', mb: 2 }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          {Object.keys(columnMapping).map(col => (
                            <th key={col} style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>
                              {col}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {fileData.slice(0, 5).map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {Object.entries(columnMapping).map(([targetCol, sourceCol]) => (
                              <td key={`${rowIndex}-${targetCol}`} style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                                {row[sourceCol] ?? '-'}
                              </td>
                            ))}
                          </tr>
                        ))}
                        {fileData.length > 5 && (
                          <tr>
                            <td colSpan={Object.keys(columnMapping).length} style={{ textAlign: 'center', padding: '8px' }}>
                              ...and {fileData.length - 5} more rows
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </Box>
                  <Typography variant="body2">
                    Total rows: {fileData.length}
                  </Typography>
                </Box>
              )}
  
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                {activeStep > 0 && (
                  <Button onClick={handleBack} sx={{ mr: 2 }}>
                    Back
                  </Button>
                )}
                {activeStep < steps.length - 1 ? (
                  <Button
                    variant="contained"
                    onClick={handleNext}
                    disabled={!file || aiMappingState === 'analyzing' || (activeStep === 1 && !requiredColumns.every(k => columnMapping[k]))}
                  >
                    Next
                  </Button>
                ) : isUploading ? (
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={stopFileUpload}
                    startIcon={<WarningAmberRoundedIcon />}
                  >
                    Stop upload
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    onClick={convertToJsonAndUpload}
                  >
                    Upload
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </Modal>
      </>
    );
  };
  
  // Custom step connector and icons (from your previous implementation)
  const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage:
          'linear-gradient( 95deg,rgb(81,134,236) 0%,rgb(81,134,236) 50%,rgb(81,134,236) 100%)',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage:
          'linear-gradient( 95deg,rgb(81,134,236) 0%,rgb(81,134,236) 50%,rgb(81,134,236) 100%)',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderRadius: 1,
    },
  }));
  
  const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
      backgroundImage:
        'linear-gradient( 136deg, rgb(81,134,236) 0%, rgb(81,134,236) 50%, rgb(81,134,236) 100%)',
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
      backgroundImage:
        'linear-gradient( 136deg, rgb(81,134,236) 0%, rgb(81,134,236) 50%, rgb(81,134,236) 100%)',
    }),
  }));
  
  function ColorlibStepIcon(props) {
    const { active, completed, className } = props;
  
    const icons = {
      1: '1',
      2: '2',
      3: '3',
    };
  
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
        {icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    );
  }
  
  ProspectFileUploadModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  };
  
  export default ProspectFileUploadModal;
